import moment from "moment";
import { LoadState } from "../../../constants/enums";
import { ICommAutomobileDriverClaims, ICommAutomobileDriverConviction, ICommAutomobileDriverInformation } from "../commAutoDriver/commAutoDriver.types";
import { ICommAutomobileInterestedParty, ICommAutomobileVehicleInformation } from "../commAutoVehicle/commAutoVehicle.types";
import { ICommAutomobileScheduleA } from "../commAutoSchedule/commAutoSchedule.types";
import { STANDARD_APP_DATE_FORMAT } from "../../../constants/constants";
import { getUniqueId } from "../../../helpers";
import { ITemplateField } from "../../CustomFormFields/CustomFormFields.types";

export interface ICommAutoPolicyChangeRequestState {
  list: ICommAutoPolicyChange[];
  policyChangeData: ICommAutoPolicyChange;
  totalRecords: number;
  loading: LoadState;
  error: string | null;
}

export interface IAutomobileAdditionalInterest {
  key: string;
  name: string | null;
  code: string | null;
  address: string | null;
  unit_or_suite: string | null;
  city: string | null;
  province_or_state: string | null;
  postal_code: string | null;
  country: string | null;
  nature_of_interest: string | null;
  vehicle_number: string | null;
  interested_party_code: string | null;
}

export interface ICommAutoPolicyChange {
  incremental_number: number | null;
  customer_id: number | null;
  customer_policy_id: number | null;
  customer_name: string | null;
  customer_code: string | null;
  cancellation_reason: string | null;
  policy_type: string;
  branch_code: string | null;
  producer_one_code: string | null;
  producer_one_id: string | null;
  policy_status: string | null;
  policy_number: string | null;
  insurer: string | null;
  policy_effective_date: string | null;
  effective_time: string | null;
  expiry_date: string | null;
  type: string | null;
  sub_type: string | null;
  // date_change: string | null;
  // time_change: string | null;
  date_created: string | null;
  effective_date: string | null;
  days_left: string | null;
  due_date: string | null;
  date_completed: string | null;
  assigned_to_id: string;
  assigned_to_name: string | null;
  current_policy_status: string | null;
  credit_card_info: {
    cc: number | null;
    expiry: string | null;
    cvv: number | null;
    account_holder_name: string | null;
    bank_name: string | null;
    institution_number: string | null;
    transit_number: string | null;
    account_number: string | null;
  };
  name_change: {
    new_name: string | null;
  };
  address_change: {
    address_type: string | null;
    address: string | null;
    address_two: string | null;
    city: string | null;
    state: string | null;
    postal_code: string | null;
    country: string | null;
  };
  driver_change: {
    type: string | null;
    delete_driver: string | null;
    records: ICommAutomobileDriverInformation[]; //JSON
  };
  driver_conviction_change: {
    type: string | null;
    delete_driver_conviction: string | null;
    records: ICommAutomobileDriverConviction[]; //JSON
  };
  driver_claim_change: {
    type: string | null;
    delete_driver_claim: string | null;
    records: ICommAutomobileDriverClaims[]; //JSON
  };
  vehicle_change: {
    type: string | null;
    delete_vehicle: string | null;
    records: ICommAutomobileVehicleInformation[]; //JSON
  };
  interested_party_change: {
    type: string | null;
    delete_interested_party: string | null;
    records: ICommAutomobileInterestedParty[]; //JSON
  };
  coverage_change: {
    type: string | null;
    delete_coverage: string | null;
    records: ICommAutomobileScheduleA[]; //JSON
  };
  attachments: {
    key: string;
    description: string | null;
    status: string | null;
    url: string | null;
    file: File | null;
  }[];
  underwriting: ITemplateField[][];
  remarks: string | null;
  status: string;
  change_request_code?: string;
  assigned_policy_number: string | null;
}

export const initialCommAutoPolicyChangeReqState: ICommAutoPolicyChangeRequestState =
  {
    policyChangeData: {
      incremental_number: null,
      customer_id: null,
      customer_policy_id: null,
      customer_name: null,
      customer_code: null,
      cancellation_reason: null,
      policy_type: "",
      branch_code: null,
      producer_one_code: null,
      producer_one_id: null,
      policy_status: null,
      insurer: null,
      policy_number: null,
      policy_effective_date: null,
      effective_time: null,
      expiry_date: moment().hours(0).minutes(1).format(STANDARD_APP_DATE_FORMAT),
      type: null,
      sub_type: null,
      // date_change: moment().format(STANDARD_APP_DATE_FORMAT),
      // time_change: moment().format(),
      date_created: moment().format(STANDARD_APP_DATE_FORMAT),
       effective_date: moment().startOf('day').add(1, 'minute').format("YYYY-MM-DD HH:mm:ss"),
      // effective_date: moment()
      //   .startOf("day")
      //   .add(1, "minute")
      //   .format("YYYY-MM-DD HH:mm:ss"),
      days_left: null,
      due_date: moment().add(5, "days").format(STANDARD_APP_DATE_FORMAT),
      date_completed: null,
      assigned_to_id: "",
      credit_card_info: {
        cc: null,
        expiry: null,
        cvv: null,
        account_holder_name: null,
        bank_name: null,
        institution_number: null,
        transit_number: null,
        account_number: null,
      },
      name_change: {
        new_name: null,
      },
      address_change: {
        address_type: null,
        address: null,
        address_two: null,
        city: null,
        state: null,
        postal_code: null,
        country: null,
      },
      driver_change: {
        type: null,
        delete_driver: null,
        records: [],
      },
      driver_conviction_change: {
        type: null,
        delete_driver_conviction: null,
        records: [],
      },
      driver_claim_change: {
        type: null,
        delete_driver_claim: null,
        records: [],
      },
      vehicle_change: {
        delete_vehicle: null,
        type: null,
        records: [],
      },
      coverage_change: {
        delete_coverage: null,
        type: null,
        records: [],
      },
      interested_party_change: {
        type: null,
        delete_interested_party: null,
        records: [],
      },

      underwriting: [],
      remarks: null,
      attachments: [
        {
          key: getUniqueId(),
          description: null,
          status: "Pending",
          url: null,
          file: null,
        },
      ],
      status: "Active",
      current_policy_status: null,
      assigned_to_name: null,
      assigned_policy_number: null,
    },
    list: [],
    totalRecords: 0,
    loading: LoadState.NotLoaded,
    error: null,
  };
